import { atom } from "jotai";

export const ad_accounts_atom = atom([]);
